import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Header() {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > lastY.current && y > 80);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => (e) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80 }}
      animate={{ y: hidden ? "-100%" : 0 }}
      transition={{ duration: hidden ? 0.5 : 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50"
    >
      <div className="mx-auto flex h-[88px] max-w-7xl items-center justify-between px-6 lg:px-10">
        <a
          href="#top"
          onClick={go("#top")}
          data-testid="header-logo"
          className="flex items-center gap-2"
          aria-label="Dolphin Retail Media — home"
        >
          <img src="/logo.webp" alt="Dolphin Retail Media" className="h-12 w-auto md:h-16" />
        </a>

        <div className="flex items-center gap-3">
          <a
            href="mailto:info@dolphin-digital.com"
            onClick={(e) => {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent("open-contact-modal"));
            }}
            data-testid="contact-support-button"
            className="btn-primary group px-5 py-2.5 text-sm"
          >
            Contact Support
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </motion.header>
  );
}
